import { Component, OnInit, Input, SimpleChanges, Optional, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit {

  @Input() panel: boolean;
  @Input() role: string;
  @Input() pafe: string;

  list: any[];
  opened: boolean;
  title: string;
  isCalendarLegend: boolean;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) data) {
    if (data) {
      this.role = data.role;
      this.panel = data.panel;
      this.title = 'Visualizza Legenda Icone';
      if (data.page) {
        if (data.page === 'calendar') {
          this.isCalendarLegend = true;
        }
      }
    }
    this.opened = false;
    this.list = [];
  }

  ngOnChanges(simpleChanges: SimpleChanges): void {
    if (simpleChanges['panel']) {
      if (simpleChanges['panel'].currentValue) {
        this.panel = simpleChanges['panel'].currentValue;
      }
    }
    if (simpleChanges['role']) {
      if (simpleChanges['role'].currentValue) {
        this.role = simpleChanges['role'].currentValue;
      }
    }
    if (simpleChanges['page']) {
      if (simpleChanges['page'].currentValue) {
        if (simpleChanges['page'].currentValue === 'calendar') {
          this.isCalendarLegend = true;
        } else {
          this.isCalendarLegend = false;
        }
      }
    }
  }

  async ngOnInit() {
    if (!this.panel) {
      this.openDialogOrMenu();
    }
  }

  openDialogOrMenu() {
    if (this.opened) {
      this.opened = !this.opened;
    } else {
      if (this.list.length > 0) {
        this.opened = !this.opened;
      } else {
        if (this.role === 'STUDENT') {
          if (this.isCalendarLegend) {
            this.list = [
              // {
              //   icon: 'remove_red_eye',
              //   text: 'Visualizza dettaglio disponibilità',
              //   color: 'blue-fg',
              //   special: false
              // },
              // {
              //   icon: 'close',
              //   color: 'grey-600-fg',
              //   text: 'Disponibilità contestata',
              //   special: false
              // },
              // {
              //   icon: 'access_time',
              //   color: 'orange-600-fg',
              //   text: 'Proponi una variazione su giorno e orario della disponibilità',
              //   special: false
              // },
              // {
              //   icon: 'access_time',
              //   color: 'grey-600-fg',
              //   text: 'Hai inviato una proposta di variazione, in attesa di conferma',
              //   special: false
              // },
              // {
              //   icon: 'priority_high',
              //   color: 'grey-600-fg',
              //   text: 'Disponibilità soggetta a disputa',
              //   special: false
              // },
              // {
              //   icon: 'sync',
              //   color: 'grey-600-fg',
              //   text: 'Il Corso è stato soggetto ad un cambio docente',
              //   special: false
              // },
              // {
              //   icon: 'warning',
              //   text: 'Apri una nuova contestazione',
              //   color: 'warn-800-fg',
              //   special: false
              // },
              // {
              //   icon: 'highlight_off',
              //   text: 'Disponibiità richiesta o acquistata non modificabile',
              //   color: 'grey-600-fg',
              //   special: false
              // }
            ];
          } else {
            this.list = [
              {
                icon: 'block',
                text: 'Non concretizzato',
                color: 'grey-400-fg',
                special: false
              },
              {
                icon: 'sync',
                text: 'In proposta',
                color: 'grey-400-fg',
                special: false
              },
              {
                icon: 'format_list_numbered',
                text: 'In preventivazione',
                color: 'grey-400-fg',
                special: false
              },
              // {
              //   icon: 'timer',
              //   text: 'In attesa di conferma da parte del docente',
              //   color: 'grey-400-fg',
              //   special: false
              // },
              {
                icon: 'euro_symbol',
                color: 'grey-400-fg',
                text: 'Pagamento non ancora effettuato',
                // text: 'Pagamento non ancora effettuato o registrato',
                special: false
              },
              {
                icon: 'euro_symbol',
                color: 'success-fg',
                text: 'Pagamento effettuato',
                // text: 'Pagamento effettuato o registrato',
                special: false
              },
              // {
              //   icon: 'sync',
              //   color: 'warn-800-fg',
              //   text: 'Richiedi cambio docente',
              //   special: false
              // },
              // {
              //   icon: '<i class="fa fa-paypal" aria-hidden="true"></i>',
              //   color: 'grey-400-fg',
              //   text: 'Pagamento scelto paypal',
              //   special: true
              // },
              {
                icon: '<i class="fa fa-paypal" aria-hidden="true" style="color: #1e88e5;"></i>',
                color: 'blue-600-fg',
                text: 'Pagato tramite paypal',
                special: true
              },
              // {
              //   icon: 'payment',
              //   color: 'grey-600-fg',
              //   text: 'Pagamento scelto bonifico bancario',
              //   special: false
              // },
              // {
              //   icon: 'payment',
              //   color: 'blue-600-fg',
              //   text: 'Pagato tramite bonifico bancario',
              //   special: false
              // },
              {
                icon: 'check',
                color: 'success-fg',
                text: 'Corso Terminato',
                special: false
              },
              {
                icon: 'directions_run',
                text: 'Corso Attivo',
                color: 'success-fg',
                special: false
              },

            ];
          }
        } else if (this.role === 'PROFESSOR') {
          if (this.isCalendarLegend) {
            this.list = [
              // {
              //   icon: 'remove_red_eye',
              //   text: 'Visualizza dettaglio disponibilità',
              //   color: 'blue-fg',
              //   special: false
              // },
              // {
              //   icon: 'edit',
              //   color: 'orange-600-fg',
              //   text: 'Modifica Disponibilità',
              //   special: false
              // },
              // {
              //   icon: 'delete',
              //   color: 'warn-800-fg',
              //   text: 'Elimina disponibilità',
              //   special: false
              // },
              // {
              //   icon: 'access_time',
              //   text: 'Disponibilità bloccata a causa di una proposta di variazione',
              //   color: 'grey-600-fg',
              //   special: false
              // },
              // {
              //   icon: 'close',
              //   color: 'grey-600-fg',
              //   text: 'Disponibilità contestata',
              //   special: false
              // },
              // {
              //   icon: 'sync',
              //   color: 'grey-600-fg',
              //   text: 'Il Corso è stato soggetto ad un cambio docente',
              //   special: false
              // },
              // {
              //   icon: 'access_time',
              //   color: 'orange-600-fg',
              //   text: 'Proponi una variazione su giorno e orario della disponibilità',
              //   special: false
              // },
              // {
              //   icon: 'access_time',
              //   color: 'grey-600-fg',
              //   text: 'Hai inviato una proposta di variazione, in attesa di conferma',
              //   special: false
              // },
              // {
              //   icon: 'priority_high',
              //   color: 'grey-600-fg',
              //   text: 'Disponibilità soggetta a disputa',
              //   special: false
              // },
              // {
              //   icon: 'highlight_off',
              //   text: 'Disponibiità richiesta o acquistata non modificabile',
              //   color: 'grey-600-fg',
              //   special: false
              // }
            ];
          } else {
            this.list = [
              {
                icon: 'block',
                text: 'Non concretizzato',
                color: 'grey-400-fg',
                special: false
              },
              {
                icon: 'sync',
                text: 'In proposta',
                color: 'grey-400-fg',
                special: false
              },
              {
                icon: 'format_list_numbered',
                text: 'In preventivazione',
                color: 'grey-400-fg',
                special: false
              },
              // {
              //   icon: 'warning',
              //   color: 'grey-400-fg',
              //   text: 'Abilita il discente al pagamento',
              //   special: false
              // },
              {
                icon: 'timer',
                color: 'default',
                text: 'In attesa di pagamento',
                special: false
              },
              // {
              //   icon: 'warning',
              //   color: 'orange-800-fg',
              //   text: 'Corso Bloccato per richiesta cambio docente',
              //   special: false
              // },
              {
                icon: 'directions_run',
                color: 'success-fg',
                text: 'Corso Attivo',
                special: false
              },
              {
                icon: 'check',
                text: 'Corso Completato',
                color: 'success-fg',
                special: false
              },
              {
                icon: 'euro_symbol',
                text: 'Corso Pagato',
                color: 'success-fg',
                special: false
              }
            ];
          }
        } else {
          this.list = [
            {
              icon: 'block',
              text: 'Non concretizzato',
              color: 'grey-400-fg',
              special: false
            },
            {
              icon: 'sync',
              text: 'In proposta',
              color: 'grey-400-fg',
              special: false
            },
            {
              icon: 'format_list_numbered',
              text: 'In preventivazione',
              color: 'grey-400-fg',
              special: false
            },
            {
              icon: 'check',
              color: 'primary-fg',
              text: 'Corso completato',
              special: false
            },
            {
              icon: 'beenhere',
              color: 'primary-fg',
              text: 'Corso Attivo',
              special: false
            },
            // {
            //   icon: 'new_releases',
            //   color: 'warn-fg',
            //   text: 'Registra pagamento discente',
            //   special: false
            // },
            // {
            //   icon: 'payment',
            //   text: 'Pagato tramite Bonifico Bancario',
            //   color: 'grey-600-fg',
            //   special: false
            // },
            {
              icon: '<i class="fa fa-paypal" aria-hidden="true"></i>',
              text: 'Pagato tramite Paypal',
              color: 'grey-400-fg',
              special: true
            },
          ];
        }
        this.opened = !this.opened;
      }
    }
  }
}
